// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__R0_9A","image":"Header_image__3C7KH","name":"Header_name__lx6tz","info":"Header_info__2tWek","infoRow":"Header_infoRow__3OJMA"};